import { LOCAL_ADS_QUERY_PARAM, LOCAL_ADS_STORAGE_KEY } from '../config/rewardedAds';

export function readViteAdsFlag(env: { VITE_CRAZYGAMES_ADS_ENABLED?: string } = import.meta.env): string | undefined {
  return env.VITE_CRAZYGAMES_ADS_ENABLED;
}

export function isLocalDevelopmentHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export function localhostAdsOverrideActive(input: {
  hostname: string;
  search?: string;
  storageGet?: (key: string) => string | null;
}): boolean {
  if (!isLocalDevelopmentHost(input.hostname)) {
    return false;
  }
  const search = input.search ?? '';
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if (params.get(LOCAL_ADS_QUERY_PARAM) === '1') {
    return true;
  }
  try {
    const stored = input.storageGet
      ? input.storageGet(LOCAL_ADS_STORAGE_KEY)
      : globalThis.localStorage?.getItem(LOCAL_ADS_STORAGE_KEY);
    return stored === '1';
  } catch {
    return false;
  }
}

/** Rewarded monetization is OFF unless the build flag is exactly `true`. */
export function isRewardedAdsEnabled(input?: {
  viteFlag?: string;
  hostname?: string;
  search?: string;
  storageGet?: (key: string) => string | null;
}): boolean {
  const viteFlag = input?.viteFlag ?? readViteAdsFlag();
  if (viteFlag === 'true') {
    return true;
  }
  const hostname =
    input?.hostname ?? (typeof location !== 'undefined' ? location.hostname : '');
  return localhostAdsOverrideActive({
    hostname,
    search: input?.search ?? (typeof location !== 'undefined' ? location.search : ''),
    storageGet: input?.storageGet,
  });
}
